import { SelectVenue } from '@/features/venue-router/ui/select-venue-button';
import { MenuFooter } from './menu-footer';
import { MenuLinks } from './menu-links';
import { MenuWrapper } from './menu-wrapper';

export const MenuV1 = () => {
    return (
        <MenuWrapper>
            <SelectVenue
                variant="default"
                media={{
                    initial: { display: 'flex', padding: 8, justifyContent: 'space-between' },
                    md: { display: 'none' },
                }}
            />
            <MenuLinks />
            <MenuFooter />
        </MenuWrapper>
    );
};
